export enum Clusters {
  SOC = "SOC",
  R = "R",
  PSY = "PSY",
  T = "T",
  A = "A",
  STR = "STR",
}
